<script>
import Swal from "sweetalert2";
import Tooltip2Vue from "@/components/Tooltip2Vue/Tooltip2Vue";
import LegoSelectCollaborator from "@/components/Lego/LegoSelectCollaborator.vue";
// import LegoBtn from "@/components/Lego/LegoBtn.vue";
import VSAvatarGroup from "@/components/Tooltip2Vue/VSAvatarGroup.vue";

export default {
  components: {
    Tooltip2Vue,
    LegoSelectCollaborator,
    // LegoBtn,
    VSAvatarGroup,
  },
  props: {
    collaborators: {
      type: Array,
      required: false,
      default: () => [],
    },
    card: {
      type: Object,
      required: true,
    },
    lite: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      deleting: [],
      isLoadingAddAssignment: false,
      isLoadingDeleteAssignment: false,
    };
  },
  computed: {
    roleLevel() {
      return this.$store.state.lego.currencyRole.level;
    },
    assignments() {
      return this.card.assignments;
    },
    selectedCollaborators() {
      if (this.assignments != undefined) {
        const data = this.assignments.map((assignment) =>
          this.collaborators.find((c) => c.id == assignment.collaboratorId)
        );
        // console.log("data", data);

        return data;
      } else {
        return [];
      }
    },
    avatarList() {
      return this.assignments?.map((a) => a.collaborator);
    },
    hasSubCards() {
      return this.card.paginatedDependents?.items?.length > 0;
    },
    isMainCard() {
      return !this.card.LegoCardId;
    },
  },
  methods: {
    async addAssignment(collaborator) {
      try {
        let applyToSubCards = false;

        // Siempre mostrar alerta para confirmar la acción
        const result = await Swal.fire({
          title: "¿Asignar responsable?",
          text:
            this.isMainCard && (this.hasSubCards || this.lite)
              ? `¿Deseas asignar a ${collaborator.name} también a las subtareas?`
              : `¿Deseas asignar a ${collaborator.name} a esta subtarea?`,
          icon: "question",
          showCancelButton: true,
          showDenyButton: this.isMainCard && (this.hasSubCards || this.lite),
          confirmButtonText:
            this.isMainCard && (this.hasSubCards || this.lite)
              ? "Sí, asignar a subtareas"
              : "Sí, asignar",
          denyButtonText: "Solo a esta tarea",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          denyButtonColor: "#6c757d",
          cancelButtonColor: "#d33",
        });

        // Si el usuario cancela completamente, salir sin hacer nada
        if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }

        applyToSubCards = this.isMainCard ? result.isConfirmed : false;

        // Solo activar el spinner después de la confirmación
        this.isLoadingAddAssignment = true;

        const assignment = {
          collaboratorId: collaborator.id,
          personaId: collaborator.personaId,
          LegoCardId: this.card.id,
          applyToSubCards: applyToSubCards,
        };

        await this.$store.dispatch("lego/addAssignment", assignment);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.isLoadingAddAssignment = false;
      }
    },
    async deleteAssignment(assignment) {
      try {
        let deleteFromSubCards = false;

        // Siempre mostrar alerta para confirmar la acción
        const result = await Swal.fire({
          title: "¿Eliminar responsable?",
          text:
            this.isMainCard && (this.hasSubCards || this.lite)
              ? `¿Deseas eliminar a ${assignment.collaborator.name} también de las subtareas?`
              : `¿Deseas eliminar a ${assignment.collaborator.name} de esta subtarea?`,
          icon: "question",
          showCancelButton: true,
          showDenyButton: this.isMainCard && (this.hasSubCards || this.lite),
          confirmButtonText:
            this.isMainCard && (this.hasSubCards || this.lite)
              ? "Sí, eliminar de subtareas"
              : "Sí, eliminar",
          denyButtonText: "Solo de esta tarea",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#d33",
          denyButtonColor: "#6c757d",
          cancelButtonColor: "#d33",
        });

        // Si el usuario cancela completamente, salir sin hacer nada
        if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }

        deleteFromSubCards = this.isMainCard ? result.isConfirmed : false;

        // Solo activar el spinner después de la confirmación
        this.isLoadingDeleteAssignment = true;
        this.deleting.push(assignment.id);

        const deleteData = {
          ...assignment,
          deleteFromSubCards: deleteFromSubCards,
        };

        await this.$store.dispatch("lego/deleteAssignment", deleteData);
        this.deleting = this.deleting.filter((id) => id != assignment.id);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.isLoadingDeleteAssignment = false;
      }
    },
  },
};
</script>

<template>
  <div class="d-flex align-items-center px-1">
    <Tooltip2Vue position="bottom">
      <slot>
        <div class="d-flex align-items-center">
          <i
            v-b-tooltip.hover
            title="Agregar responsables"
            class="fas fa-chevron-down mr-2 text-white-50"
          ></i>
          <span v-if="!selectedCollaborators.length">
            {{ selectedCollaborators.length + " Resp." }}
          </span>
          <VSAvatarGroup :listAvatars="avatarList" :max="lite ? 3 : 5" />
        </div>
      </slot>
      <template #tooltip>
        <div class="tp-container">
          <div class="mb-2">
            <p>
              <span>Responsables</span>
              <i
                v-if="isLoadingAddAssignment || isLoadingDeleteAssignment"
                class="fas fa-spinner fa-spin ml-2"
              ></i>
            </p>
          </div>
          <LegoSelectCollaborator
            v-if="roleLevel < 3"
            :selectedCollaborators="selectedCollaborators"
            :collaborators="collaborators"
            @input="addAssignment"
          />
          <div class="responsables">
            <div
              class="responsable"
              v-for="assignment in assignments"
              :key="assignment.id"
            >
              <div class="persona">
                <div>
                  <i class="fa-regular fa-user"></i>
                </div>
                <div>
                  <span>
                    {{ assignment.collaborator.name }}
                  </span>
                </div>
              </div>
              <div @click="deleteAssignment(assignment)" v-if="roleLevel < 3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon-minus"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Tooltip2Vue>
  </div>
</template>

<style scoped>
/* Los estilos de .btn-shadow ahora están estandarizados en _lego-control-buttons.scss */

.tp-container {
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  border-radius: 8px;
  cursor: auto;
  width: 300px;
  text-align: start;
  border: solid 1px rgba(0, 0, 0, 0.25);

  .dark & {
    border: solid 1px rgba(255, 255, 255, 0.25);
  }
}

.responsable:first-of-type {
  margin-top: 1rem;
}

.responsable {
  display: flex;
  padding: 0.75rem 0;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.icon-minus {
  transition: 0.3s;
  height: 24px;
  width: 24px;
  border-radius: 5px;
  cursor: pointer;
  stroke: silver;
}

.icon-minus:hover {
  /* background-color: rgba(255,255,255,.2); */
  stroke: var(--lego-danger);
}

.persona {
  display: flex;
  gap: 0.5rem;
}
</style>
